export default "__VITE_ASSET__ia2_zGZB__"